var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489",
    transform: "translate(-590 -639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10484",
    "data-name": "Group 10484",
    transform: "translate(0 125.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2906",
    "data-name": "Ellipse 2906",
    transform: "translate(590 513.751)",
    fill: "#f2efef",
    stroke: "#7e59d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    strokeDasharray: "4 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.6,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_49_",
    "data-name": "svgexport-6 (49)",
    transform: "translate(549.266 645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488",
    transform: "translate(47.734 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10486",
    "data-name": "Group 10486",
    transform: "translate(0.143 0.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10675",
    "data-name": "Path 10675",
    d: "M62.829,14.487a17.057,17.057,0,0,0,0,2.313,4,4,0,0,1-.6.088c-.491.049-1.341.1-2.748.1a28.6,28.6,0,0,1-3.9-.189,15.7,15.7,0,0,0-.23-2.455c1.961-.314,4.79-1.62,4.79-3.393a1.03,1.03,0,0,0-1.171-1.067,1.407,1.407,0,0,0-1.346,1.041,12.256,12.256,0,0,1-2.387-.827S55.3,7.81,58.32,7.528c.2-.019.409-.028.633-.028A3.776,3.776,0,0,1,62.6,9.484s1.411,2.755-1.87,5.06a13.66,13.66,0,0,0,2.1-.057Z",
    transform: "translate(-55.239 -7.5)",
    fill: "#eff4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10676",
    "data-name": "Path 10676",
    d: "M221.1,14.487a17.057,17.057,0,0,0,0,2.313,4,4,0,0,1-.6.088c-.021-.65-.017-1.442-.007-1.787a10.917,10.917,0,0,1-1.551.012l-1.518-.161,1.249-.877a4.965,4.965,0,0,0,1.507-1.576,3.174,3.174,0,0,0,.416-1.383,2.974,2.974,0,0,0-.234-1.371l-.013-.025-.006-.015a4.763,4.763,0,0,0-3.756-2.177c.2-.019.409-.028.633-.028a3.776,3.776,0,0,1,3.651,1.984s1.411,2.755-1.87,5.06A13.66,13.66,0,0,0,221.1,14.487Z",
    transform: "translate(-213.508 -7.5)",
    fill: "#daeaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10677",
    "data-name": "Path 10677",
    d: "M92.534,44.252a4.8,4.8,0,0,0,2.237.284q.268,0,.579-.02c-.01.326-.014.75,0,1.212-.148.016-.338.032-.58.048-.489.031-1.187.056-2.166.056-1.675,0-2.77-.075-3.339-.129-.026-.569-.087-1.106-.14-1.487A9.583,9.583,0,0,0,91.91,43.1a3.383,3.383,0,0,0,1.932-2.731,1.544,1.544,0,0,0-.569-1.272,1.867,1.867,0,0,0-1.175-.368,1.905,1.905,0,0,0-1.671.943,12.161,12.161,0,0,1-1.418-.5,2.1,2.1,0,0,1,.309-.622,2.268,2.268,0,0,1,.886-.712,3.99,3.99,0,0,1,1.4-.335h0q.227-.017.472-.017A3.228,3.228,0,0,1,95.2,39.122a.361.361,0,0,0,.018.039,2.977,2.977,0,0,1,.233,1.371,3.174,3.174,0,0,1-.416,1.383,4.326,4.326,0,0,1-.554.741,9.367,9.367,0,0,1-1.948,1.6Z",
    transform: "translate(-88.364 -36.916)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10485",
    "data-name": "Group 10485",
    transform: "translate(3.242 0.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10678",
    "data-name": "Path 10678",
    d: "M228.875,40.533a3.174,3.174,0,0,1-.416,1.383,4.326,4.326,0,0,1-.554.741c1.636-4.38-1.938-5.051-2.876-5.151q.227-.017.472-.017a3.228,3.228,0,0,1,3.122,1.633.358.358,0,0,0,.018.039A2.978,2.978,0,0,1,228.875,40.533Z",
    transform: "translate(-225.029 -37.49)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M390.353,406.811c-.148.016-.338.032-.58.048a8.768,8.768,0,0,1,0-1.24q.268,0,.579-.02C390.339,405.926,390.335,406.349,390.353,406.811Z",
    transform: "translate(-386.605 -398.571)",
    fill: "#7e59d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10487",
    "data-name": "Group 10487",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M109.38,5.494a3.883,3.883,0,0,0,.507-1.693,3.651,3.651,0,0,0-.308-1.735,3.211,3.211,0,0,0-.8-1.039A4.357,4.357,0,0,0,105.8,0a4.494,4.494,0,0,0-2.745.758.143.143,0,1,0,.172.229,4.22,4.22,0,0,1,2.573-.7,4.683,4.683,0,0,1,1.7.3,3.6,3.6,0,0,1,1.078.65,2.965,2.965,0,0,1,.739.949l0,.01A3.414,3.414,0,0,1,109.6,3.8a3.6,3.6,0,0,1-.475,1.564A5.4,5.4,0,0,1,107.5,7.07a.143.143,0,0,0,.067.26,12.926,12.926,0,0,0,1.956-.044,17.667,17.667,0,0,0,0,2.043,17.276,17.276,0,0,1-2.536.157.143.143,0,0,0,0,.286h0a13.062,13.062,0,0,0,2.723-.191.143.143,0,0,0,.1-.148,17.05,17.05,0,0,1,0-2.291.143.143,0,0,0-.154-.154c-.809.062-1.347.074-1.672.071a5.4,5.4,0,0,0,1.388-1.564Z",
    transform: "translate(-101.941 0)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10681",
    "data-name": "Path 10681",
    d: "M58,310.323a32.074,32.074,0,0,1-3.757-.171,16.089,16.089,0,0,0-.208-2.213,9.406,9.406,0,0,0,2.761-.981.143.143,0,1,0-.139-.25,9.062,9.062,0,0,1-2.809.973.143.143,0,0,0-.118.167,15.682,15.682,0,0,1,.228,2.429.143.143,0,0,0,.121.141,28.506,28.506,0,0,0,3.922.191.143.143,0,1,0,0-.286Z",
    transform: "translate(-53.617 -300.834)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M50.4,65.165a1.255,1.255,0,0,1,1.207-.933c.894,0,1.028.579,1.028.924a2.63,2.63,0,0,1-1.33,1.951.143.143,0,1,0,.163.236,2.806,2.806,0,0,0,1.454-2.187,1.141,1.141,0,0,0-.406-.935,1.568,1.568,0,0,0-2.1.3,1.786,1.786,0,0,0-.247.439,12.369,12.369,0,0,1-2.141-.746,2.494,2.494,0,0,1,.529-1.224.143.143,0,1,0-.223-.18,2.694,2.694,0,0,0-.6,1.486.143.143,0,0,0,.081.133,12.265,12.265,0,0,0,2.419.838A.144.144,0,0,0,50.4,65.165Z",
    transform: "translate(-47.734 -61.561)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10683",
    "data-name": "Path 10683",
    d: "M82.907,30.617a4.284,4.284,0,0,1,1.813-.338,3.1,3.1,0,0,1,2.992,1.548.143.143,0,1,0,.262-.116,2.705,2.705,0,0,0-.733-.9,3.9,3.9,0,0,0-2.52-.813,4.563,4.563,0,0,0-1.934.365,2.409,2.409,0,0,0-.941.757,2.232,2.232,0,0,0-.331.665.143.143,0,0,0,.082.174,12.3,12.3,0,0,0,1.435.5.143.143,0,0,0,.16-.063,1.771,1.771,0,0,1,1.549-.874,1.726,1.726,0,0,1,1.086.337,1.405,1.405,0,0,1,.514,1.159,3.251,3.251,0,0,1-1.864,2.609,9.47,9.47,0,0,1-2.737,1.1.143.143,0,0,0-.11.159c.049.355.113.9.139,1.474a.143.143,0,0,0,.13.136c.625.059,1.713.13,3.352.13a27.3,27.3,0,0,0,2.761-.1.143.143,0,0,0,.128-.148c-.015-.389-.016-.794,0-1.2a.143.143,0,0,0-.15-.147,8.481,8.481,0,0,1-2.49-.157,9.8,9.8,0,0,0,1.423-1.139,5.266,5.266,0,0,0,.885-1.092,3.271,3.271,0,0,0,.377-2.277.143.143,0,0,0-.281.056,2.985,2.985,0,0,1-.345,2.08A7.48,7.48,0,0,1,85.1,36.777a.143.143,0,0,0-.063.154c.012.052.057.084.12.113a7.082,7.082,0,0,0,2.688.269c-.007.316-.006.629,0,.933-.467.043-1.273.089-2.6.089-1.524,0-2.567-.061-3.2-.117-.026-.474-.075-.919-.118-1.247a9.745,9.745,0,0,0,2.7-1.105,3.514,3.514,0,0,0,2-2.853A1.682,1.682,0,0,0,86,31.631a2.008,2.008,0,0,0-1.264-.4,2.036,2.036,0,0,0-1.734.919,12.026,12.026,0,0,1-1.176-.411,1.937,1.937,0,0,1,.246-.457,2.126,2.126,0,0,1,.832-.667Z",
    transform: "translate(-80.863 -29.419)",
    fill: "#2a2a2a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2-icon.b92536759f10f7dac6d293cf70ed1297.svg";
export { ForwardRef as ReactComponent };